import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import { Provider } from "react-redux";
import store, { persistor } from "./store";
import { PersistGate } from "redux-persist/integration/react";
import LoadingScreen from "./components/LoadingScreen";
// import * as Sentry from "@sentry/react";
// import { BrowserTracing } from "@sentry/tracing";

import * as serviceWorker from "./serviceWorker";
import "./assets/fonts.css";
import "./assets/typescale.css";

// Sentry.init({
//   dsn: "https://011f1f9ac5f049168ffda37a26c08327@o1386961.ingest.sentry.io/6707743",
//   integrations: [new BrowserTracing()],

//   // Set tracesSampleRate to 1.0 to capture 100%
//   // of transactions for performance monitoring.
//   // We recommend adjusting this value in production
//   tracesSampleRate: 1.0,
//   environment: process.env.NODE_ENV,
//   enabled: process.env.NODE_ENV !== "development",
// });

const container = document.getElementById("root");
const root = createRoot(container);

root.render(
  <Provider store={store}>
    <PersistGate persistor={persistor} loading={<LoadingScreen />}>
      <App />
    </PersistGate>
  </Provider>,
);

// Production keeps the PWA service worker. In development, actively unregister
// any lingering worker — a stale one serves a CACHED old build and makes new
// code appear to "not show up" no matter how many times you refresh.
if (process.env.NODE_ENV === "production") {
  serviceWorker.register();
} else {
  serviceWorker.unregister();
}
